import { withUser } from 'components/queries/GetUserQuery';
import PrintCta from './PrintCta';

export default withUser(PrintCta);
